import { addDays, setHours, setMinutes } from 'date-fns/fp'
import { ANS } from '~/reactapp/story/ans/types'
import { get } from 'lodash'
import { isAfter, parseISO } from 'date-fns'
import intl from 'react-intl-universal'
import { LabelDate } from '~/reactapp/shared/DatePicker/DatePickerInput'
import moment from 'moment-timezone'
interface QuickPickValue {
  /**
   * Number of days offset from today (0), must be positive value as you cannot
   * publish in the past
   */
  dayOffset: number
  /**
   * Represents a 24 time value, e.g., "18:00"
   */
  time: string
}

/**
 * This function takes the tab param that is the active tab
 * also takes the story (ANS object), when active tab is 0 (Planning Tab)
 * the state at `planning.scheduling.planened_plublish_date`
 * because it is used at the planned ready time form
 */
function getPlannedPublishDate(story: ANS) {
  const plannedPublishDate: string | null | undefined = get(
    story,
    'planning.scheduling.planned_publish_date'
  )

  let plannedPublishDateObj = moment(
    plannedPublishDate !== undefined ? plannedPublishDate : null
  )
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tz = (window as any).org_settings.timezone
  if (tz) {
    // tz is only undefined in unit tests
    plannedPublishDateObj = plannedPublishDateObj.tz(tz)
  }
  return plannedPublishDateObj.format('Y-MM-DDTHH:mm')
}

/**
 * Shape of quick pick values stored in settings,
 * see html/modules/services/settings.js
 */
export interface QuickPickTimes {
  publish: QuickPickValue[]
  scheduled: QuickPickValue[]
}

export function getDatesFromSettings(
  times: QuickPickTimes,
  type: keyof QuickPickTimes
) {
  const quickPickForType = times[type].filter(
    (pickVal) =>
      pickVal && pickVal.dayOffset !== undefined && pickVal.time !== undefined
  )

  if (quickPickForType.length === 0 && type === 'scheduled') {
    // Default quick pick times for scheduled
    quickPickForType.push({ dayOffset: 0, time: '6:00' })
    quickPickForType.push({ dayOffset: 1, time: '18:00' })
  }

  // convert to Date objs
  return quickPickForType.map((val) => {
    const addOffset = addDays(val.dayOffset)
    const [hours, minutes] = val.time.split(':').map(Number)
    const setTimeHours = setHours(hours)
    const setTimeMinutes = setMinutes(minutes)

    return setTimeMinutes(setTimeHours(addOffset(new Date())))
  })
}

export function getQuickPickDates(
  story: ANS,
  times: QuickPickTimes,
  now: Date,
  type: keyof QuickPickTimes
) {
  const fromSettings: LabelDate[] = getDatesFromSettings(times, type).map(
    (date) => ({
      date,
    })
  )
  const plannedPublish: string | undefined = getPlannedPublishDate(story)
  const quickDates =
    plannedPublish !== undefined && plannedPublish !== ''
      ? [
          ...fromSettings,
          {
            date: parseISO(plannedPublish),
            label: intl.get('publishActions.publishModal.boltPlanned'),
          },
        ]
      : fromSettings

  return [
    { date: now },
    ...quickDates
      .filter((d) => isAfter(d.date, now))
      .sort((a, b) => a.date.getTime() - b.date.getTime()),
  ]
}
